import { Result } from "antd";
import { useTranslation } from "react-i18next";
import { placementClassName, type PagePlacement } from "./pagePlacement";

/** Модулът не се зареди и презареждането не помогна (или не е разрешено) —
 *  само текст, без бутони. */
export default function ModuleLoadFailed({ placement }: { placement: PagePlacement }) {
  const { t } = useTranslation();
  return (
    <div className={placementClassName(placement)}>
      <Result status="warning" title={t("common.moduleLoadFailed")} />
    </div>
  );
}
